import { ChevronsUpDown } from 'lucide-react'
import { ReactNode } from 'react'

import * as Input from '@/components/input'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/popover'

import { LoaderCircle } from '../loader-circle'

interface ComboboxProps {
  value?: string
  label: string
  openPopoverCombobox: boolean
  handleUpdateValuePopoverCombobox: (value: boolean) => void
  withError?: boolean
  children: ReactNode
  placeholder: string
  isModal?: boolean
  disabled?: boolean
  datatestid?: string
  isLoading?: boolean
}

function Combobox({
  value,
  label,
  children,
  handleUpdateValuePopoverCombobox,
  openPopoverCombobox = false,
  withError,
  placeholder,
  isModal = false,
  disabled = false,
  datatestid,
  isLoading = false,
}: ComboboxProps) {
  return (
    <Popover
      modal={isModal}
      open={disabled ? false : openPopoverCombobox}
      onOpenChange={(value) => {
        if (!disabled) {
          handleUpdateValuePopoverCombobox(value)
        }
      }}
    >
      <PopoverTrigger disabled={disabled} asChild>
        <div className="w-full text-start">
          <Input.Label
            htmlFor="entity"
            mandatory
            onClick={(e) => e.stopPropagation()}
            data-testid={`${datatestid}-label`}
          >
            {label}
          </Input.Label>
          <Input.Root withError={withError}>
            <Input.Control
              disabled={disabled}
              className="cursor-pointer"
              id="entity"
              readOnly
              placeholder={placeholder}
              value={value}
              data-testid={`${datatestid}-input`}
            />
            <Input.Prefix>
              {isLoading ? (
                <LoaderCircle />
              ) : (
                <ChevronsUpDown className="text-monochromatic-300" />
              )}
            </Input.Prefix>
          </Input.Root>
        </div>
      </PopoverTrigger>

      {!disabled && (
        <PopoverContent className="w-[var(--radix-popover-trigger-width)]">
          {children}
        </PopoverContent>
      )}
    </Popover>
  )
}

export { Combobox }
